<p-dialog
  [(visible)]="displaySelectTemplatesDialog"
  [position]="'center'"
  [modal]="true"
  [style]="{ width: '50vw', margin: '0' }"
  [draggable]="false"
  [resizable]="false"
  styleClass="order-dialog">
  <ng-template pTemplate="header">
    <div class="header-modal pb-4 has-border w-100 d-flex align-items-center">
      <h2 class="me-3">Select Template</h2>
      <a
        [class.disabledanchortag]="!(selectedTemplate?.id ?? 0 > 0)"
        class="add-new add-new ms-auto"
        (click)="deleteTemplate()"
        ><i class="icon-Delete"></i> Delete</a
      >
      <a class="add-new add-new ms-2" (click)="showAddNewTemplateDialog()"
        ><i class="icon-Add"></i> Add New</a
      >
    </div>
  </ng-template>

  <p-table
    #dt
    [value]="filerLinesTemplatesListing"
    styleClass="p-datatable-customers stockListing"
    [rowHover]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="false"
    [filterDelay]="0"
    [(selection)]="selectedTemplate"
    selectionMode="single"
    [rowHover]="true"
    scrollHeight="250px"
    dataKey="id">
    <ng-template pTemplate="header">
      <tr>
        <th class="type">Title</th>
        <th class="descp">
          Description
          <p-columnFilter
            type="text"
            field="description"
            display="menu"></p-columnFilter>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-templateListing let-rowIndex="rowIndex">
      <tr [pSelectableRow]="templateListing" class="p-selectable-row">
        <td class="title">{{ templateListing.title }}</td>
        <td class="description" [innerHTML]="templateListing.description"></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No templates found.</td>
      </tr>
    </ng-template>
  </p-table>
  <ng-template pTemplate="footer">
    <div class="d-flex py-3 justify-content-end has-sticky gap-3">
      <p-button
        label="Cancel"
        (click)="closeTemplateDialog()"
        variant="outlined"
        severity="secondary" />

      <p-button
        label="Add"
        (click)="selectAddTemplate()"
        [disabled]="!(selectedTemplate?.id ?? 0 > 0)" />
    </div>
  </ng-template>
</p-dialog>

<jni-workflow-line-templates-form
  [displayAddNewTemplateModal]="displayAddNewTemplateModal"
  (closeAddUpdateTemplateDialogEvent)="closeAddUpdateTemplateDialogEvent()"
  (closeAndRefreshTemplatesGridEvent)="
    closeAndRefreshTemplatesGridEvent()
  "></jni-workflow-line-templates-form>
